import React from 'react';
import './TermsPage.scss';

const TermsPage: React.FC = () => {
  const terms = [
    'Įmonės atstovas, registruodamas įmonę cvgidas.lt portale patvirtina, kad turi visus įgaliojimus tai atlikti ir įmonės vardu vykdyti visus personalo paieškos ir atrankos darbus.',
    'Įmonė pilnai atsako už jų atstovų Cvgidas.lt portale atliekamus veiksmus ir skelbiamą informaciją.',
    'Įmonės duomenys, prieš patvirtinant juos sistemoje, gali būti patikrinti. CV gidas.lt administracija turi teisę šalinti neatitinkančius tikrovės duomenis.',
    'Cvgidas.lt administracija taip pat turi teisę šalinti duomenis, kurie pažeidžia etikos normas, diskredituoja sistemos administratorius, kitus sistemos vartotojus, ar suteikia jiems materialinę arba moralinę žalą.',
    'Cvgidas.lt įsipareigoja suteikti paslaugas taip, kaip aprašyta svetainėje esančiame paslaugų aprašyme, o įmonė įsipareigoja už atliktas paslaugas sumokėti pagal paslaugų įsigijimo metu portale www.cvgidas.lt skelbiamas kainas.',
    'Cvgidas paslaugos suteikiamos per 24 valandas nuo apmokėjimo datos. Paslaugų teikimo laikas pradedamas skaičiuoti nuo jos aktyvavimo momento.',
    'Įmonė turi teisę atsisakyti paslaugos ir atgauti sumokėtą įmoką, jeigu įrodyta, kad paslauga buvo suteikta nekokybiškai, nesilaikant portale skelbiamo paslaugos aprašymo.',
    'Įmonė turi teisę paslaugos teikimo metu pratęsti paslaugos galiojimo laiką, ar įsigyti papildomų paslaugų.',
    'Įmonė neturi teisės siūlyti kandidatams bet kurio kito kandidatavimo būdo, išskyrus kandidatavimą per cvgidas.lt sistemą. Draudžiama nurodyti kontaktinius duomenis ne tam skirtuose duomenų laukuose.',
    'Cvgidas turi teisę sustabdyti skelbimo publikavimą sistemoje, jeigu paaiškėja, kad skelbimas pažeidžia Lietuvos respublikos įstatymus, teisės aktus, etikos ar moralės normas.',
    'Įmonė gali naudotis cv gidas duomenų bazės duomenimis išskirtinai darbuotojų paieškos ir įdarbinimo tikslais. Draudžiama duomenų bazėje esančius duomenis perduoti trečiosioms šalims be Cvgidas.lt raštiško sutikimo, išskyrus įstatymų numatytus atvejus.',
    'Įvesdama duomenis į cvgidas.lt duomenų bazę, įmonė neįgyja tos duomenų bazės dalies autorinių teisių.',
    'Įmonė įsipareigoja nenaudoti jokios papildomos kompiuterių ar programinės įrangos priemonių duomenų bazės informacijos peržiūrėjimui arba jos išsaugojimui.',
    'Cvgidas.lt gali naudoti įmonės duomenis statistikos arba rinkodaros tikslais bendrame susistemintų duomenų kontekste.',
    'Įmonės nurodytu elektroninio pašto adresu cvgidas.lt gali siųsti informaciją, pranešimus, susijusius su portalo vykdoma veikla, ar teikiamomis paslaugomis.',
    'Cvgidas.lt turi teisę pakeisti duomenų bazės ir portalo struktūrą, prieš tai iš anksto neinformavusi sistemos vartotojų, tačiau įsipareigoja apie visus atliktus pakeitimus pranešti elektroniniu paštu.',
    'Cvgidas.lt turi teisę savo nuožiūra keisti šias sąlygas. Naujos sąlygos pradeda galioti nuo jų paskelbimo.',
    'Cvgidas.lt turi teisę vienašališkai nutraukti įmonės registraciją, jeigu įmonė nesilaiko taisyklėse esančių įsipareigojimų.',
  ];

  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Naudojimosi sąlygos</h1>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-section">
        <div className="terms-container">
          <ol className="terms-list">
            {terms.map((term, index) => (
              <li key={index}>{term}</li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;




